import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";

Vue.use(VueRouter);

let routes = [];
store.getters.pages.forEach(page => {
  const component = page.component.split(";")[0];
  routes.push({
    path: page.path,
    name: page.component,
    component: () => import( `../views/${component}.vue`),
    meta: {
      index: routes.length,
      transition: page.transition,
    },
  });
});


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
});

export default router;
